import { tlISODateTimeToLocalNoSecondsString, NotificationSendService, BaseTLDetailComponent, AxiosResponse, RightHelper, Watch } from "../../../Infrastructure/CorBase/CoreBase";


export default abstract class NotificationViewDetailBase extends BaseTLDetailComponent {


	returnRoute: string = "NotificationViewList";
	notificationSendService: NotificationSendService = new NotificationSendService();	

	returnStudentId = '';

	createBase() {	
		//if (this.$router.currentRoute.query.returnId != '') {
		//	this.returnStudentId = this.$router.currentRoute.query.returnId.toString();
		//}
		this.changeReadNotification();
	}

	//TEST
	@Watch('$route', { immediate: true, deep: true })
	onUrlChange(newVal: any) {
		if (this.formData.id != this.objectIdFromQuery) {
			this.formData.id = this.objectIdFromQuery;
			this.fetchDataFromServer().then(res => {
				this.formData.subject = '';
				this.processResponse(res);
				this.changeReadNotification();
			});
		}
	}

	public changeReadNotification() {
		if (this.formData.readDate == '') {
			this.notificationSendService.readNotifications([this.formData.id]).then(res => {
				this.formData.readDate = tlISODateTimeToLocalNoSecondsString(res.data);
				var countNewNotification = this.$store.state.notificationCount - 1;
				this.$store.commit("notificationCount", countNewNotification);

			}).catch((error) => {
				super.showAlertModalWithErrorMessageList(error);
			});
		}
	}

	///hlaska o prekroceni inputu po Ctrl+V
	protected infoShortInputBase(maxLength: string): void {
		this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), this.$t('global.messageShortInput').toString() + maxLength + this.$t('global.messageShortInput2').toString());
	}

	formData = {
		id: 0 as number,
		subject: '' as string,
		body: '' as string,
		idPersonNavigation: '' as string,
		sendStatus: '' as string,
		sendPortalDate: '' as string,
		sendAddress: '' as string,
		readDate: '' as string,
		person: null
	}

	protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
		return this.notificationSendService.getById(this.objectId);
	}

	protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
		return super.NoCall()
	}

	protected refreshItems(items: any, refreshData: any): any {
		return items;
	}

	protected showSendAgainBase() {
		return RightHelper.currentUserHasRight('COR_NotificationSend_Update');
	}

	protected processResponse(response: AxiosResponse<any>): void {
		this.formData.id = response.data.id;
		this.formData.subject = response.data.subject;
		this.formData.body = response.data.body;
		this.formData.idPersonNavigation = response.data.idPersonNavigation;
		this.formData.sendStatus = response.data.sendStatus;
		this.formData.sendAddress = response.data.sendAddress;
		this.formData.sendPortalDate = tlISODateTimeToLocalNoSecondsString(response.data.sendPortalDate);
		this.formData.readDate = tlISODateTimeToLocalNoSecondsString(response.data.readDate);
		this.formData.person = response.data.person;
	}

	protected afterCreate(response: AxiosResponse<any>): void {
		this.formData.id = response.data.id;
	}


	sendAgainBase() {
		var idSendAgain = [];
		idSendAgain.push(this.formData.id);
		this.isBusy = true;
		this.notificationSendService.sendAgain(idSendAgain).then(res => {
			this.isBusy = false;
		}).catch(error => {
			this.showAlertModalWithErrorMessage(this.$t('errorsall.errorMessageSendAgain').toString());
			this.isBusy = false;
		});
	}

	sendTemplateTestBase(idPerson: number, idTemplate: number) {
		this.formData.id = idTemplate;
		this.notificationSendService.sendNotificationToPerson(idPerson, idTemplate).then(res => {
		});
	}

	doAction() {
		super.doCRUDActionWithInfoMessage(this.$t('notificationSend.messageNew').toString(), this.$t('notificationSend.messageEdit').toString(), this.$t('notificationSend.messageDelete').toString());
	}

	protected updateObject(): Promise<AxiosResponse<any>> {
		return this.notificationSendService.update(this.objectId, this.formData);
	}

	protected createObject(): Promise<AxiosResponse<any>> {
		return this.notificationSendService.create(this.formData);
	}

	protected deleteObject(): Promise<AxiosResponse<any>> {
		return this.notificationSendService.delete(this.objectId);
	}



}
